'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (_ref) {
    var include = _ref.include,
        exclude = _ref.exclude;

    var completeBlackList = ['Query', 'Mutation'].concat(Array.isArray(exclude) ? exclude : []);

    if (include) {
        if (Array.isArray(include)) {
            return function (type) {
                return include.includes(type.name);
            };
        }

        if (typeof include === 'function') {
            return function (type) {
                return !completeBlackList.includes(type.name) && include(type);
            };
        }
    }

    if (exclude && typeof exclude === 'function') {
        return function (type) {
            return !completeBlackList.includes(type.name) && !exclude(type);
        };
    }

    return function (type) {
        return !completeBlackList.includes(type.name);
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/aor-simple-graphql-client/lib/introspection/filterWithIncludeExclude.js
// module id = 293
// module chunks = 0